import { Box, ColorOptions, Icon, Spacer, Text } from '@jfs/ui-new'
import { FlatList } from 'react-native'
import { SvgImage } from '../../../comps/SvgImage'
import { Colors } from '../../../util/util'

export const listItem = [
  {
    title: 'UPI',
    value: 'UPI',
    icon: 'BhimIcon',
  },
  {
    title: 'Cash',
    value: 'CASH',
    icon: 'RupeeIconFilled',
  },
]

const renderItem = ({ item, selected, onSelectItem }) => {
  const isCheck = item.value === selected
  return (
    <Box
      flexDirection={'row'}
      align="center"
      marginVertical={10}
      testID={'mop-' + item.value.replaceAll(' ', '')}
      onPress={() => onSelectItem(item.value)}
      underlayColor="TRANSPARENT">
      <Box underlayColor="LIGHTEST_GREY_2" pr={10}>
        <Icon id={isCheck ? 'RADIOBUTTON_ON' : 'RADIOBUTTON_OFF'} color={isCheck ? 'PRIMARY' : 'BLACK'} size={20} />
      </Box>
      <SvgImage imageName={item.icon} />
      <Spacer size={10} direction="horizontal" />
      <Text color={Colors.BLACK_14 as ColorOptions} fontSize={14} fontFamily={'JioType-Medium'}>
        {item.title}
      </Text>
    </Box>
  )
}

export const ModeOfPayment = ({ value, fieldName, setFieldValue }: any) => {
  const onSelectItem = (value: any) => {
    setFieldValue(fieldName, value)
  }
  return (
    <Box mt={40}>
      <Text color={Colors.BLACK_14 as ColorOptions} fontSize={16} fontFamily={'JioType-Bold'}>
        Customer Mode of Payment
      </Text>
      <Spacer size={10} direction="vertical" />
      <FlatList
        contentContainerStyle={{ padding: 0, margin: 0 }}
        renderItem={({ item }) => renderItem({ item, selected: value, onSelectItem })}
        showsVerticalScrollIndicator={false}
        data={listItem}
      />
    </Box>
  )
}
